export type SymbolToRule = { [key: string]: string };

class LSystem {
    axiom: string;
    rules: SymbolToRule;
    constructor(axiom: string, rules: SymbolToRule) {
        this.axiom = axiom;
        this.rules = rules;
    }

    getAxiom(): string {
        return this.axiom;
    }

    getRule(symbol: string): string {
        return this.rules[symbol];
    }
}

export default LSystem;
